import { render, staticRenderFns } from "./MasterDiscountCodeDetailContent.vue?vue&type=template&id=0fb67587"
import script from "./MasterDiscountCodeDetailContent.vue?vue&type=script&lang=js"
export * from "./MasterDiscountCodeDetailContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports